// extracted by css-extract-rspack-plugin
module.exports =  {"bundleArchivedItemSection":"ArchivedItemIndicator__bundleArchivedItemSection___syILS"};